module.exports = __webpack_public_path__ + "static/media/gallery-1.4c28c087.jpg";